<template>
  <nav class="navbar navbar-expand-lg bg-light sticky-top" id="topElement">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img src="/images/adpad-logo.png" class="logo img-fluid" />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon">
          <i class="fas fa-bars pt-1"></i>
        </span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <div class="my-2 my-lg-0">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a href="#" class="nav-link" v-scroll-to="'#about-us'">About Us</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" v-scroll-to="'#services'">Services</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" v-scroll-to="'#achievements'">Achievements</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link" v-scroll-to="'#contact'">Contact</a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >Download</a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">
                  <a
                    href="/docs/Sponsorship Proposal-Lokstar.pdf"
                    target="_blank"
                  >Sponsorship Proposal</a>
                </a>
                <a class="dropdown-item" href="#">
                  <a href="/images/sliderImages/homeslider.jpg" target="_blank">Adpad Banner</a>
                </a>
              </div>
            </li>
            <div>
              <a href="http://ans.com.np/" target="_blank">
                <img src="/images/ansco.png" class="img-fluid pt-3 ml-5" />
              </a>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>


<style scoped>
.logo {
  width: 150px;
}

.nav-link {
  color: #111111;
  display: block;
  padding: 25px 15px;
  position: relative;
  font-weight: bold;
  font-size: 0.9rem;
}

.dropdown-menu {
  background: #f5f5f5;
}
.dropdown-item {
  padding: 15px;
}
.dropdown-item a {
  padding: 25px;
  color: #111;
}

.navbar-toggler {
  border-color: #111;
  border-width: 2px;
}
.navbar-toggler-icon {
  color: #111 !important;
}

@media only screen and (min-width: 1025px) {
  .nav-link {
    float: left;
    margin-left: 35px;
    position: relative;
  }
}
</style>